export enum ApplicationSettings {
  accountingPackage = 'AccountingPackage',
  allocateFullRolls = 'AllocateFullRolls',
  allowBlankDespatchNoteSearch = 'AllowBlankDespatchNoteSearch',
  allowBlankProductSearch = 'AllowBlankProductSearch',
  allowCustomerPortalInvites = 'AllowCustomerPortalInvites',
  allowSupplierProductSearchOption = 'AllowSupplierProductSearchOption',
  autoConfirmOrders = 'AutoConfirmOrders',
  autoLoadEnquiries = 'AutoLoadEnquiries',
  customerKey = 'CustomerKey',
  emailCSVFile = 'EmailCSVFile',
  forecastMinimumStockCalculation = 'ForecastMinimumStockCalculation',
  hideExportHeadings = 'HideExportHeadings',
  includeAgentCommissionOnSalesAnalysis = 'IncludeAgentCommissionOnSalesAnalysis',
  invoiceFromPicking = 'InvoiceFromPicking',
  magentoWebsite = 'MagentoWebsite',
  mandatoryOrderSource = 'MandatoryOrderSource',
  overDeliveryPercentageAllowed = 'OverDeliveryPercentageAllowed',
  partDespatchNotAllowed = 'PartDespatchNotAllowed',
  printSplitStockLabels = 'PrintSplitStockLabels',
  sendCustomsDeclarationsTo = 'SendCustomsDeclarationsTo',
  showLabelSelection = 'ShowLabelSelection',
  showMargin = 'ShowMargin',
  showOrderPosition = 'ShowOrderPosition',
  showPrintOptions = 'ShowPrintOptions',
  showVatAnalysisOnDocuments = 'ShowVatAnalysisOnDocuments',
  stockProperty1Description = 'StockProperty1Description',
  stockProperty2Description = 'StockProperty2Description',
  stockProperty3Description = 'StockProperty3Description',
  summariseBatches = 'SummariseBatches',
}
